import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, first, map } from 'rxjs';
import {
	PagedRequestDto,
	RecordHistoryClient,
	RecordHistoryDto,
} from './api.service';
import { FuseLoadingService } from '@fuse/services/loading';

@Injectable({
	providedIn: 'root',
})
export class ShortcutService {
	private _shortcuts: BehaviorSubject<RecordHistoryDto[]> =
		new BehaviorSubject<RecordHistoryDto[]>([]);

	constructor(
		private _recordHistoriesClient: RecordHistoryClient,
		private _fuseLoadingService: FuseLoadingService
	) {}

	get(): Observable<RecordHistoryDto[]> {
		let request = PagedRequestDto.fromJS({
			pageSize: 10,
			page: 0,
		});

		return this._recordHistoriesClient.getList(request).pipe(
			map((x) => {
				let shortcuts = x.records.map((y) =>
					RecordHistoryDto.fromJS(y)
				);

				this._shortcuts.next(shortcuts);

				return shortcuts;
			})
		);
	}

	setShortcuts(shortcut: RecordHistoryDto) {
		let shortcuts = this._shortcuts.getValue();

		this._fuseLoadingService.setDisableProgressBar(true);

		this._recordHistoriesClient
			.post(shortcut)
			.pipe(first())
			.subscribe({
				next: () => {
					// If the shortcut already exists, remove it
					const index = shortcuts.findIndex(
						(x) => x.url === shortcut.url
					);
					if (index > -1) shortcuts.splice(index, 1);

					shortcuts.unshift(shortcut);
					shortcuts = shortcuts.slice(0, 10);
					this._shortcuts.next(shortcuts);
				},
			});

		this._fuseLoadingService.setDisableProgressBar(false);
	}

	get getShortcuts(): Observable<RecordHistoryDto[]> {
		return this._shortcuts.asObservable();
	}
}
